import CookieBanner from "@/Components/UI/Cookies/CookieBanner";
import CookieSettings from "@/Components/UI/Cookies/CookieSettings";

export default function CookieManager() {
    return (
        <>
            <CookieSettings />
            <CookieBanner />
        </>
    );
}
